import React from 'react';
import {
  parseImgSizes,
  getLargestSize,
  getPixelDensity,
  addParamsToUrl,
  getSrcSet,
} from './scripts/utils';
import { ImageProps } from './types';
import { classNames } from '../../utils/style';

export const Image = ({
  pixelDensity,
  className,
  sizes,
  ...props
}: ImageProps) => {
  if (!props.src) return null;
  if (!sizes) return;

  const sizesString = Array.isArray(sizes) ? sizes.join(', ') : sizes;
  const sizesObject = sizesString && parseImgSizes(sizesString);
  const maxWidth = sizesObject && getLargestSize(sizesObject);
  const dpr = pixelDensity ? getPixelDensity(pixelDensity) : 1;
  const quality = 90;

  const isSvg = props?.src?.endsWith('.svg');
  const srcParams = {
    auto: 'format',
    dpr: dpr,
    q: quality,
    w: maxWidth,
  };

  const handleOnLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.classList.remove('opacity-0');
  };

  /** Hubspot */
  if (props.src.includes('{{module')) return; // prevent if build hubspot
  if (props.src.includes('hubspotusercontent'))
    return (
      <img
        {...props}
        className={classNames(
          'opacity-0 transition-all duration-500',
          className,
        )}
        loading={props.loading || 'lazy'}
        decoding={props.decoding || 'async'}
        alt={props.alt || ''}
        src={props.src}
        sizes={!isSvg ? sizesString : undefined}
        onLoad={handleOnLoad}
        aria-hidden={props?.['aria-hidden'] || !props.alt ? true : false}
      />
    );

  /** Website */
  const src = isSvg ? props.src : addParamsToUrl(props.src, srcParams);

  const srcSet =
    !isSvg &&
    sizesObject &&
    getSrcSet(props.src, sizesObject, { dpr, quality });

  return (
    <img
      {...props}
      className={classNames('opacity-0 transition-all duration-500', className)}
      loading={props.loading || 'lazy'}
      decoding={props.decoding || 'async'}
      alt={props.alt || ''}
      src={src}
      srcSet={srcSet ? srcSet : undefined}
      sizes={!isSvg ? sizesString : undefined}
      onLoad={handleOnLoad}
      aria-hidden={props?.['aria-hidden'] || !props.alt ? true : false}
    />
  );
};
